// Global Components
import * as React from 'react';
import {
  FormGroup,
  Label,
} from 'reactstrap';
import {
  AvInput,
} from 'availity-reactstrap-validation';
import CreatableSelect from 'react-select/creatable';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $OptionalProps = {
  disabled?: boolean;
  label?: string;
  onChange?: (value: null | string) => unknown;
  required?: boolean;
  value?: null | string;
};

type $Props = $OptionalProps & {
  name: string;
  onError: (arg0: Error) => unknown;
};

type $Value = {
  label: string;
  value: string;
};

type $State = {
  activeValue: Array<$Value>;
  stringValue: null | string;
};

class InputCreatableView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    disabled: undefined,
    label: undefined,
    onChange: undefined,
    required: undefined,
    value: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      activeValue: [],
      stringValue: null,
    };
  }

  componentDidMount(): void {
    this.setInitialValue();
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      value,
    } = this.props;

    if (isDiff(
      prevProps.value,
      value,
    )) {
      this.setInitialValue();
    }
  }

  setInitialValue(): void {
    const {
      onError,
      value,
    } = this.props;

    let activeValue: Array<$Value> = [];

    if (value) {
      try {
        activeValue = JSON.parse(value);
      } catch (error) {
        if (onError) {
          onError(error as Error);
        }
      }
    }

    const stringValue: string = JSON.stringify(activeValue);

    this.setState({
      activeValue,
      stringValue,
    });
  }

  setValue(activeValue: Array<$Value>): void {
    const {
      onChange,
    } = this.props;

    const stringValue: string = JSON.stringify(activeValue);

    this.setState({
      activeValue,
      stringValue,
    });

    if (onChange) {
      onChange(stringValue);
    }
  }

  render() {
    const {
      disabled,
      label,
      name,
      required,
    } = this.props;
    const {
      activeValue,
      stringValue,
    } = this.state;

    return (
      <FormGroup className={'InputCreatable'}>
        {label && (
          <Label>
            {label}
          </Label>
        )}
        <CreatableSelect
          isDisabled={disabled}
          isMulti
          name={`_${name}`}
          onChange={(newValue) => {
            const newActiveValue = newValue as Array<$Value>;

            this.setValue(newActiveValue);
          }}
          options={activeValue}
          required={required}
          value={activeValue}
        />
        <AvInput
          name={name}
          style={{
            display: 'none',
          }}
          value={stringValue}
        />
      </FormGroup>
    );
  }
}

export default InputCreatableView;
